import * as React from 'react';

const DEFAULT_TITLE = 'Magicline Sign-up';

export const useBrowserTitle = (title?: string): void => {
    React.useEffect(() => {
        document.title = title || DEFAULT_TITLE;
    }, [title]);
};
